import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fold",
  "use": "fold-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol viewBox=\"0 0 20 16\" id=\"fold\">\n<defs>\n    <style>\n      #fold .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M1721,66h18a1,1,0,1,1,0,2h-18A1,1,0,1,1,1721,66Zm0,14h18a1,1,0,1,1,0,2h-18A1,1,0,1,1,1721,80Zm-0.58-8.99h9.16a1.4,1.4,0,0,1,0,2h-9.16A1.4,1.4,0,0,1,1720.42,71.01Zm0,3.979h9.16a1.4,1.4,0,0,1,0,2h-9.16A1.4,1.4,0,0,1,1720.42,74.99ZM1735.5,77l-3.5-6h7Z\" transform=\"translate(-1720 -66)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fold.svg
// module id = UWrL
// module chunks = 264